import { useMutation, useQueryClient } from "react-query";

import { queryKeyPrefix } from "api/services/treatment/hooks/useGetTreatmentSchedules";
import { useApiClient } from "api/useApiClient";

import type { PostTreatmentSchedulePayload, TreatmentScheduleTemplate } from "../schemas/Treatment";

export const usePostTreatmentSchedule = () => {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation<TreatmentScheduleTemplate, Error, PostTreatmentSchedulePayload>({
    mutationFn: args => client.postTreatmentSchedule(args),
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeyPrefix);
    },
  });
};
